import { useEffect } from "react";
import { config } from '@config'

export function ChatScript() {
    useEffect(() => {
        if (config.showChat) {
            const injectChatScript = (windowObj: any, documentObj: Document, chatId: string) => {
                const scriptId = "giosg-chat-script";

                if (documentObj.getElementById(scriptId)) {
                    return;
                }

                const scriptTag = documentObj.createElement("script");
                const firstScript = documentObj.getElementsByTagName("script")[0];
                const chatServiceUrl = "https://service.giosg.com";

                scriptTag.id = scriptId;
                scriptTag.async = true;
                scriptTag.src = `${chatServiceUrl}/live2/${chatId}`;

                windowObj._giosg = windowObj._giosg || function () {
                    (windowObj._giosg._e = windowObj._giosg._e || []).push(arguments);
                };

                windowObj._giosg._c = chatId;
                windowObj._giosg._h = chatServiceUrl;

                if (firstScript?.parentNode) {
                    firstScript.parentNode.insertBefore(scriptTag, firstScript);
                }
            };

            injectChatScript(window as any, document, "ae25f548-e000-11ed-8843-0242ac120017");
        }
    }, []);

    return null;
}